exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".checkbox{display:flex;flex-direction:row;align-items:center;justify-content:center;margin-top:8px}.checkbox .title{font-weight:bold;width:50%;text-align:right}.checkbox .controls{width:50%}.checkbox .controls input{margin-left:32px}", ""]);

